import {
  computed,
  Injectable,
  Signal,
  signal,
  TemplateRef,
} from '@angular/core';

export type ToolbarSlot = 'left' | 'center' | 'right';

@Injectable({
  providedIn: 'root',
})
export class ToolbarBridgeService {
  private _portalContent = signal<Record<string, TemplateRef<unknown> | null>>(
    {},
  );

  hasContent(toolbarId: string) {
    return computed(() => {
      const state = this._portalContent();
      const prefix = `${toolbarId}:`;

      return Object.keys(state).some(
        (key) => key.startsWith(prefix) && state[key] !== null,
      );
    });
  }

  getSlot(name: string): Signal<TemplateRef<unknown> | null> {
    return computed(() => this._portalContent()[name] ?? null);
  }

  updateSlot(
    toolbarId: string,
    slot: string,
    template: TemplateRef<unknown> | null,
  ): void {
    const key = `${toolbarId}:${slot}`;
    console.log('updating: ', key);
    this._portalContent.update((prev) => ({ ...prev, [key]: template }));
  }
}
